import React, { useState, useEffect } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
// react-router-dom components
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SpaceShip from "pages/components/Icons/SpaceShip";
import PageLayout from "pages/components/LayoutContainers/PageLayout";
import "@progress/kendo-theme-default/dist/all.css";
import KendoButton from "assets/theme/components/button/kendo";
import KendoInput from "assets/theme/components/inputKendo";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "redux-store/auth/actions";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import "assets/theme/components/styles.css";
import { loginReset } from "redux-store/auth/reducers";
import Footer from "pages/components/Footer";
import Logo from "../../../assets/images/logos/flex2logo.png";
import SoftButton from "components/SoftButton";
import { Checkbox, Divider, FormControlLabel } from "@mui/material";
import StripeImg from "assets/images/stripcard.png";
import CommonApiService from "api/common.api";
import FinancialsApiService from "api/financials.api";
import { getUser } from "redux-store/auth/actions";
import { handleUnAuthorizedAction } from "redux-store/auth/reducers";
import { logoutUser } from "redux-store/auth/actions";
import CardElementContainer from "./stripe/CardElementContainer";

const cardElementOptions = {
  style: {
    base: {
      fontSize: "16px",
      fontWeight: 400,
      color: "#050F2F",
      "::placeholder": {
        color: "#9A98A8",
      },
    },
    invalid: {
      color: "#f54e4e",
      iconColor: "#f54e4e",
    },
  },
  hidePostalCode: true,
};

const CheckoutComponent = ({ formik, error, handleShippingAddressChange, options = {} }) => {
  const [loading, setLoading] = React.useState(false);
  const [counrties, setCounrties] = React.useState(null);
  const [states, setStates] = React.useState(null);

  const getCountries = async () => {
    try {
      setLoading(true);
      const response = await CommonApiService.getCountries();
      setCounrties(response?.data?.data);
    } catch (error) {
      console.error(error);
      if (!!error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error(error?.message || "Something went wrong");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCountries();
  }, []);

  const getStates = async () => {
    try {
      setLoading(true);
      const response = await CommonApiService.getStates();
      setStates(response?.data?.data);
    } catch (error) {
      console.error(error);
      if (!!error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error(error?.message || "Something went wrong");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCountries();
    getStates();
  }, []);

  return (
    <Grid item xs={11} md={6} lg={4}>
      <Card sx={{ padding: 4 }}>
        <SoftBox>
          <SoftBox>
            <SoftTypography variant="h6" mb={1}>
              Payment details
            </SoftTypography>
          </SoftBox>
          <CardElementContainer cardElementOptions={cardElementOptions} />
          {error && <div className="form-error error">{error}</div>}
          <SoftTypography variant="h6" mt={3}>
            Billing Address{" "}
          </SoftTypography>
          <SoftBox mb={2} mt={1}>
            <KendoInput
              placeholder="First name"
              name="firstName"
              maxLength="100"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.firstName}
            />
            {formik.touched.firstName && formik.errors.firstName ? (
              <div className="form-error error">{formik.errors.firstName}</div>
            ) : null}
          </SoftBox>
          <SoftBox mb={2} mt={1}>
            <KendoInput
              placeholder="Last Name"
              name="lastName"
              maxLength="100"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.lastName}
            />
            {formik.touched.lastName && formik.errors.lastName ? (
              <div className="form-error error">{formik.errors.lastName}</div>
            ) : null}
          </SoftBox>
          <SoftBox mb={2}>
            <KendoInput
              placeholder="Enter address line 1"
              name="addressLineOne"
              maxLength="100"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.addressLineOne}
            />
            {formik.touched.addressLineOne && formik.errors.addressLineOne ? (
              <div className="form-error error">{formik.errors.addressLineOne}</div>
            ) : null}
          </SoftBox>
          <SoftBox mb={2}>
            <KendoInput
              placeholder="Enter address line 2"
              name="addressLineTwo"
              maxLength="100"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.addressLineTwo}
            />
            {formik.touched.addressLineTwo && formik.errors.addressLineTwo ? (
              <div className="form-error error">{formik.errors.addressLineTwo}</div>
            ) : null}
          </SoftBox>
          <SoftBox mb={2}>
            <KendoInput
              placeholder="Enter City"
              name="city"
              maxLength="100"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.city}
            />
            {formik.touched.city && formik.errors.city ? (
              <div className="form-error error">{formik.errors.city}</div>
            ) : null}
          </SoftBox>
          <SoftBox mb={2}>
            <KendoInput
              placeholder="Enter State"
              name="state"
              maxLength="100"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.state}
            />
            {formik.touched.state && formik.errors.state ? (
              <div className="form-error error">{formik.errors.state}</div>
            ) : null}
          </SoftBox>
          <SoftBox mb={2}>
            <select
              name="state"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.state}
              className="custom-select"
            >
              <option value={""}> Select State </option>
              {states?.map((option) => (
                <option key={option.id} value={option.name}>
                  {option.name}
                </option>
              ))}
            </select>
            {formik.touched.state && formik.errors.state ? (
              <div className="form-error error">{formik.errors.state}</div>
            ) : null}
          </SoftBox>
          <SoftBox mb={2}>
            <select
              name="country"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.country}
              className="custom-select"
              disabled
            >
              <option value={""}> Select Country </option>
              {counrties?.map((option) => (
                <option key={option.id} value={option.nicename}>
                  {option.nicename}
                </option>
              ))}
            </select>
            {formik.touched.country && formik.errors.country ? (
              <div className="form-error error">{formik.errors.country}</div>
            ) : null}
          </SoftBox>
          <SoftBox mb={2}>
            <KendoInput
              placeholder="Enter zip code"
              name="zipCode"
              maxLength="10"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.zipCode}
            />
            {formik.touched.zipCode && formik.errors.zipCode ? (
              <div className="form-error error">{formik.errors.zipCode}</div>
            ) : null}
          </SoftBox>

          <SoftTypography variant="h6" mt={3}>
            Shipping Address{" "}
          </SoftTypography>
          <SoftBox mb={2} ml={2}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formik.values.useBillingAddress}
                  onChange={handleShippingAddressChange}
                  name="useBillingAddress"
                  disabled={loading}
                />
              }
              label="Same As Billing Address"
            />
          </SoftBox>
          {!formik.values.useBillingAddress && (
            <>
              <SoftBox mb={2} mt={1}>
                <KendoInput
                  placeholder="First name"
                  name="firstName"
                  maxLength="100"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.firstName}
                />
                {formik.touched.firstName && formik.errors.firstName ? (
                  <div className="form-error error">{formik.errors.firstName}</div>
                ) : null}
              </SoftBox>
              <SoftBox mb={2} mt={1}>
                <KendoInput
                  placeholder="Last Name"
                  name="lastName"
                  maxLength="100"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.lastName}
                />
                {formik.touched.lastName && formik.errors.lastName ? (
                  <div className="form-error error">{formik.errors.lastName}</div>
                ) : null}
              </SoftBox>
              <SoftBox mb={2}>
                <KendoInput
                  placeholder="Enter address line 1"
                  name="addressLineOne"
                  maxLength="100"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.addressLineOne}
                />
                {formik.touched.addressLineOne && formik.errors.addressLineOne ? (
                  <div className="form-error error">{formik.errors.addressLineOne}</div>
                ) : null}
              </SoftBox>
              <SoftBox mb={2}>
                <KendoInput
                  placeholder="Enter address line 2"
                  name="addressLineTwo"
                  maxLength="100"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.addressLineTwo}
                />
                {formik.touched.addressLineTwo && formik.errors.addressLineTwo ? (
                  <div className="form-error error">{formik.errors.addressLineTwo}</div>
                ) : null}
              </SoftBox>
              <SoftBox mb={2}>
                <KendoInput
                  placeholder="Enter City"
                  name="city"
                  maxLength="100"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.city}
                />
                {formik.touched.city && formik.errors.city ? (
                  <div className="form-error error">{formik.errors.city}</div>
                ) : null}
              </SoftBox>
              <SoftBox mb={2}>
                <KendoInput
                  placeholder="Enter State"
                  name="state"
                  maxLength="100"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.state}
                />
                {formik.touched.state && formik.errors.state ? (
                  <div className="form-error error">{formik.errors.state}</div>
                ) : null}
              </SoftBox>
              <SoftBox mb={2}>
                <select
                  name="state"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.state}
                  className="custom-select"
                >
                  <option value={""}> Select State </option>
                  {states?.map((option) => (
                    <option key={option.id} value={option.name}>
                      {option.name}
                    </option>
                  ))}
                </select>
                {formik.touched.state && formik.errors.state ? (
                  <div className="form-error error">{formik.errors.state}</div>
                ) : null}
              </SoftBox>
              <SoftBox mb={2}>
                <select
                  name="country"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.country}
                  className="custom-select"
                  disabled
                >
                  <option value={""}> Select Country </option>
                  {counrties?.map((option) => (
                    <option key={option.id} value={option.nicename}>
                      {option.nicename}
                    </option>
                  ))}
                </select>
                {formik.touched.country && formik.errors.country ? (
                  <div className="form-error error">{formik.errors.country}</div>
                ) : null}
              </SoftBox>
              <SoftBox mb={2}>
                <KendoInput
                  placeholder="Enter zip code"
                  name="zipCode"
                  maxLength="10"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.zipCode}
                />
                {formik.touched.zipCode && formik.errors.zipCode ? (
                  <div className="form-error error">{formik.errors.zipCode}</div>
                ) : null}
              </SoftBox>
            </>
          )}

          <Grid container mt={2} spacing={2}>
            <Grid item xs={12}>
              <KendoButton
                type="submit"
                label={(loading || options?.loading === true) ? "Processing..." : options?.buttonText || "Submit"}
                loading={loading}
                disabled={loading}
              />
            </Grid>
            <Grid item xs={12}>
              <SoftTypography variant="p" component="p" fontSize="medium" textAlign={"center"}>
                <b>Note:</b> Your payment is secured with <b>Stripe</b>
              </SoftTypography>
            </Grid>
          </Grid>
        </SoftBox>
      </Card>
    </Grid>
  );
};

export default CheckoutComponent;
